import(/* webpackMode: "eager" */ "/tmp/8de2e5b95142159/app/[locale]/error.tsx");
